// src/features/rrhh/mensajeria/components/ReclamosFilters.jsx
import {
  Button,
  InputAdornment,
  Stack,
  TextField,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

export default function ReclamosFilters({
  search,
  setSearch,
  hasSelection,
  onOpenDetalle,
  onOpenEstado,
  onOpenResponder,
}) {
  return (
    <Stack spacing={1.5}>
      <Stack direction="row" spacing={1} sx={{ flexWrap: "wrap", alignItems: "center" }}>
        <TextField
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Buscar empleado"
          size="small"
          sx={{
            flex: 1,
            "& .MuiOutlinedInput-root": {
              height: 40,
              borderRadius: "20px",
              bgcolor: (t) => t.palette?.neutral?.[50],
              boxShadow: "inset 0px 0px 2px rgba(96, 96, 113, 0.45)",
              "& fieldset": { border: "none" },
            },
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <SearchIcon sx={{ color: (t) => t.palette?.primary?.[900], opacity: 0.9 }} />
              </InputAdornment>
            ),
          }}
        />

        <Stack
          direction="row"
          spacing={1}
          sx={{
            py: 0.75,
            px: 1.5, 
            borderRadius: "20px",
            bgcolor: (t) => t.palette?.neutral?.[50],
            boxShadow: "inset 0px 0px 2px rgba(96, 96, 113, 0.45)",
            flexWrap: "wrap",
          }}
        >
          <Button
            disabled={!hasSelection}
            onClick={onOpenDetalle}
            sx={{
              borderRadius: 999,
              bgcolor: (t) => t.palette?.secondary?.[500],
              color: "common.white",
              fontSize: "14px",
              "&:hover": { bgcolor: (t) => t.palette?.secondary?.[600] },
            }}
          >
            Ver detalle
          </Button>

          <Button
            disabled={!hasSelection}
            onClick={onOpenEstado}
            sx={{
              borderRadius: 999,
              bgcolor: (t) => t.palette?.secondary?.[500],
              color: "common.white",
              fontSize: "14px",
              "&:hover": { bgcolor: (t) => t.palette?.secondary?.[600] },
            }}
          >
            Cambiar estado
          </Button>

          <Button
            disabled={!hasSelection}
            onClick={onOpenResponder}
            sx={{
              borderRadius: 999,
              bgcolor: (t) => t.palette?.secondary?.[500],
              color: "common.white",
              fontSize: "14px",
              "&:hover": { bgcolor: (t) => t.palette?.secondary?.[600] },
            }}
          >
            Responder
          </Button>
        </Stack>
      </Stack>
    </Stack>
  );
}
